import http from '@/api/api.js'
import Vue from 'vue'
import store from '../store/index.js'
import {Message} from 'element-ui'
export default function del() {
	this.arr = [];
	this.curItem = {};
	this.init = function (array) {
		this.arr = JSON.parse(JSON.stringify(array));
		this.resetIndex();
	};
	// 获取所有条码
	this.resetIndex = function () {
		for (let i = 0; i < this.arr.length; i++) {
			for (let a = 0; a < this.arr[i].goodsList.length; a++) {
				this.arr[i].goodsList[a].twoIndex = a;
				this.arr[i].goodsList[a].oneIndex = i;
			}
			this.arr[i].index = i;
		}
	};
	// 定位条码位置 [n,n]
	this.getPositionForCode = function () {
		for (let i = 0; i < this.arr.length; i++) {
			for (let a = 0; a < this.arr[i].goodsList.length; a++) {
				console.log(this.arr[i], 'this.arr[i]this.arr[i]');
				console.log(this.curItem, 'this.curItemthis.curItem');
				if (
					this.arr[i].goodsList[a].barcode === this.curItem.barcode
				) {
					return [i, a]  // 第一个相同条码就返回
				}
			}
		}
		return [-1, -1]
	};
	// 获取匹配的一级的index        通过key:value 获取 一级商品的index
	this.getOneIndex = function (goods) {
		for (let i = 0; i < this.arr.length; i++) {
			if (
				this.arr[i].goodsId === goods.goodsId
				&& this.arr[i].skus === goods.skus
				&& this.arr[i].unitId === goods.unitId
				&& this.arr[i].petId === goods.petId
			) {
				return i
			}
		}
		return -1;
	};
	// 删除（ isCheck===true:删二级 ）
	this.del = function (posi, isCheck) {
		if (!isCheck) {
			isCheck = false;
		}
		if (isCheck == false) {
			this.arr.splice(posi[0], 1);
		} else {
			this.arr[posi[0]].num--;
			this.arr[posi[0]].goodsList.splice(posi[1], 1);
			if (this.arr[posi[0]].goodsList.length === 0) {
				this.del(posi)
			}
		}
		this.resetIndex();
	};
	this.searchGoods = function ({ obj }) {
		console.log(obj, 'searchGoodssearchGoods')
		let code = obj.code
		let shopId = obj.shopid
		code = (code).toString().trim();
		// if(obj===undefined){
		// 	obj = {}
		// 	obj.can9 = false  // 是否限制已销售状态的条码
		// 	obj.allShop = false  // 是否限制门店
		// }else{
		// 	obj.can9 = obj.can9===undefined?false:obj.can9
		// 	obj.allShop = obj.allShop===undefined?false:obj.allShop
		// }
		return new Promise((resolve, reject) => {
			http.get(process.env.VUE_APP_Url_baseData + '/api/product/goods/from/code/getinfoandshopstock', {
				// http.get('/api/Goods/barcodeGoodsInfo', {
				barcode: code,
				shopId: shopId
			}).then(res => {
				if (res.code == 0) {
					
					let goods = res.data;
					console.log(goods, 'goods录入条码信息');
					let curPetInfo = store.getters['mendian/curPetInfo'];
					let item = {
						activityId: '',
						activityType: 1,
						activityItem: {},
						activityList: [],
						barcode: goods.barcode,
						totaTimes: goods.totaTimes, // 总次数
						useTimes: goods.useTimes,   // 已使用次数
						onlyTimes: goods.totaTimes - goods.useTimes,
						tableKey: 'tableKey' + Math.random(),
						petId: curPetInfo._id ? curPetInfo._id : '',
						petName: curPetInfo._id ? curPetInfo.nick_name : '',
						brand: goods.brand,
						is_discount:goods.is_discount,
						discount_unit:goods.discount_unit?goods.discount_unit:'',
						discount_unitId:goods.discount_unitId?goods.discount_unitId:'',
						discount_price:goods.discount_price?goods.discount_price:'',
						categoryId: goods.category_info._id,
						categoryName: goods.category_info.name,
						huotiType: code.length === 15 ? 1 : 0,
						goodsId: goods.goodsId,
						goodsName: goods.goodsName,
						goodsType: goods.goodsType, //  0:商品 1:药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.卡 7.耗材 8.组合套餐
						goodsUsage: "", // 用法
						goodsDosage: "", // 用量
						costPrice: goods.costPrice,
						num: 1, // 数量
						skus: goods.skus,
						skuValue: goods.skuValue,
						unitId: goods.unitId,
						unit: goods.unit,
						totalMoney: goods.min_price,
						stock: goods.stock,
						staff: [],  // 销售人员
						validityStopDate: goods.validityStopDate, // 有效期
						goodsList: [],
						giftList: [],
						checkGoods: [],
						saleWays: goods.saleWays,//规格
						sale_way_packing_exchange: goods.sale_way_packing_exchange, //不同规格的库存
						packingExchangesStr: goods.packingExchangesStr,
						category_list: goods.category_list,
						buyBack: goods.buy_back || 0,
						

					}

					this.curItem = item;
					resolve(this.curItem);
				}
			}).catch(err => {
				reject(err);
			})
		})
	}
	this.searchGood = function(code){

		code = (code).toString().trim();
		return new Promise((resolve,reject)=>{
			http.get(process.env.VUE_APP_Url_baseData + '/api/product/goods/from/code', {
				barcode: code
			}).then(res=>{
				if(res.code==0){
					let goods = res.data;
					let item = {
						activityId: '',
						activityType: 1,
						activityItem: {},
						activityList: [],
						barcode: goods.barcode,
						totaTimes: goods.totaTimes, // 总次数
						useTimes: goods.useTimes,   // 已使用次数
						onlyTimes: goods.totaTimes - goods.useTimes,
						tableKey: 'tableKey' + Math.random(),
						brand: goods.brand,
						categoryId: goods.categoryId,
						categoryName: goods.categoryName,
						huotiType: code.length === 15 ? 1 : 0,
						goodsId: goods.goodsId,
						goodsName: goods.goodsName,
						goodsType: goods.goodsType, //  0:商品 1:药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.卡 7.耗材 8.组合套餐
						goodsUsage: "", // 用法
						goodsDosage: "", // 用量
						costPrice: goods.costPrice,
						num: 1, // 数量
						skus: goods.skus,
						skuValue: goods.skuValue,
						unitId: goods.unitId,
						unit: goods.unit,
						totalMoney: goods.min_price,
						stock: goods.stock,
						staff: [],  // 销售人员
						validityStopDate: goods.validityStopDate, // 有效期
						goodsList: [],
						giftList: [],
						checkGoods: [],
						saleWays: goods.saleWays,//规格
						sale_way_packing_exchange: goods.sale_way_packing_exchange, //不同规格的库存
						packingExchangesStr: goods.packingExchangesStr,
						category_info: goods.category_info,
						category_list: goods.category_list,
						buyBack: goods.buy_back || 0,
					}
					this.curItem = item;
					resolve(this.curItem);
				}
			}).catch(err=>{
				reject(err);
			})
		})
	}
	// 商品添加到arr
	this.addGoods = function (oneStaffArr) {
		this.curItem.staff = oneStaffArr
		let index = this.getOneIndex(this.curItem);
		console.log(index, this.curItem, '条码存在');
		let wayItem = this.curItem.sale_way_packing_exchange.filter((item) => {
			return item['salePackingWayId'] == this.curItem.unitId
		})[0];

		let exchangeCount = wayItem.exchangeCount;
		let tureCount = 1;

		if (index >= 0) {
			tureCount = this.arr[index].num + 1;
		}
		//库存不足
		if (exchangeCount * tureCount > this.curItem.stock) {
			console.log('没有库存');
			Message({
				message: "已没有库存！",
				type: "error",
			});
			return false;
		}
		//库存充足，继续执行

		if (index >= 0) {
			this.arr[index].num++;  
		} else {
			this.curItem.tableKey = 'tableKey' + Math.random();
			this.arr.push(this.curItem);
			console.log(this.arr,'this.arr');
		}
		return true;

	};
	this.addGroup = function (groupItem, goodsList, curIndex, oneStaffArr) {
		let arr = []
		for (let i = 0; i < goodsList.length; i++) {
			for (let a = 0; a < goodsList[i].goodsList.length; a++) {
				arr.push(goodsList[i].goodsList[a])
			}
		}
		if (curIndex === -1) {
			let curPetInfo = store.getters['mendian/curPetInfo'];
			let group = {
				tableKey: Math.random(),
				petId: curPetInfo._id ? curPetInfo._id : '',
				petName: curPetInfo._id ? curPetInfo.nick_name : '',
				"goodsId": groupItem.groupId,
				"goodsName": groupItem.title,
				"goodsType": 8,
				originalPrice: groupItem.total_money, // 原价
				price: groupItem.total_money, // 现价
				costPrice: groupItem.total_money,
				vipPrice: groupItem.total_money,
				"brand": '',
				"categoryId": groupItem.category_info._id,
				"categoryName": groupItem.category_info_name,
				"skus": '',
				"skuValue": '',
				"unitId": '',
				"unit": '',
				"num": 1,
				goodsList: arr,
				groupTableData: goodsList,
				groupObj: groupItem,
				staff: oneStaffArr,
				buyBack: 0,
			}
			this.curItem = group;
			this.arr.push(group)
		} else {
			this.arr[curIndex].goodsList = arr;
			this.arr[curIndex].groupTableData = goodsList;
			this.curItem = this.arr[curIndex];
		}
		this.resetIndex();
	}
	// this.getAllCodeState=function(){
	// 	return new Promise((resolve)=>{
	// 		let params=[]
	// 		for(let i=0;i<this.arr.length;i++){
	// 			for(let a=0;a<this.arr[i].goodsList.length;a++){
	// 				if(this.arr[i].goodsList[a].barcode){
	// 					params.push(this.arr[i].goodsList[a].barcode)
	// 				}
	// 			}
	// 			let giftList = this.arr[i].giftList;
	// 			for(let a=0;a<giftList.length;a++){
	// 				for(let b=0;b<giftList[a].goodsList.length;b++){
	// 					if(giftList[a].goodsList[b].barcode){
	// 						params.push(giftList[a].goodsList[b].barcode)
	// 					}
	// 				}
	// 			}
	// 		}
	// 		http.post('/api/Goods/GetCodeStatusInfo', params).then(res=>{
	// 			resolve(res)
	// 		})
	// 	})
	// }废弃
}

